
import React, { useEffect, useState } from 'react';
import { Document, Page, PDFViewer, View, Font } from '@react-pdf/renderer';


import { styles, pageStyle } from './examReportCardStyles.js';
import { HeaderLogoSection, HeaderAddressSection, HeaderNameSection } from './headerSection.js';
import StudentSection from './studentSection.js';
import { ScoreSection } from './scoreSection.js';
import FooterSection from './footerSection.js';

// import LstReportCard from "./lstReportCard.json";

Font.register({
  family: 'Calibri'
  , fonts: [{ src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibri.ttf" }
    , { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibrib.ttf", fontWeight: "bold" }], format: 'truetype'
});

const ExamReportCardPDF = (props) => {

  const [lstReportCard, setLstReportCard] = useState(props.lstReportCard);


  useEffect(() => {
    // console.log("ExamReportCardPDF called", "props.lstReportCard ", props.lstReportCard);
  }, [props.reportCardObj]);

  const pages = [];

  for (let i = 0; i < lstReportCard.length; i++) {
    pages.push(
      <Page
        key={lstReportCard[i].studentSection.studentId}
        size="A4" style={pageStyle.page}>
        <View style={pageStyle.page_border}>
          <View style={pageStyle.header_section}>
            <View style={pageStyle.header_logo}>
              <HeaderLogoSection
                logoUrl={props.logoUrl}
                headerSection={lstReportCard[i].headerSection}
              />
            </View>
            <View style={pageStyle.header_address}>
              <HeaderAddressSection
                headerSection={lstReportCard[i].headerSection}
              />
            </View>
            <View style={pageStyle.header_name}>
              <HeaderNameSection
                headerName={lstReportCard[i].headerName}
              />
            </View>
          </View>
          <View style={pageStyle.student_section}>
            <StudentSection
              studentSection={lstReportCard[i].studentSection}
              />
          </View>
          <View style={pageStyle.score_section}>
            <ScoreSection
              scoreSection={lstReportCard[i].scoreSection}
              exam={props.exam}
            />
          </View>
          <View style={pageStyle.footer_section}>
            <FooterSection />
          </View>
        </View>
      </Page>
    );
  }


  return (
    <div className='col-sm-12 padding-remove' >
      <PDFViewer style={{ width: "100%", height: "600px", overflowY: "scroll" }}>
        <Document>{pages}</Document>
      </PDFViewer>
    </div>
  );
}

export default ExamReportCardPDF;

